export enum TravelTimeTransport {
    CAR = 1,
    PUBLIC_TRANSPORT = 2
}
export enum TravelTimeTransport {
    CAR = 1,
    PUBLIC_TRANSPORT = 2
}
